<template>
  <section class="flash-sale">
    <div class="flash-sale__content">
      <h1 class="flash-sale__title">Flash Certification Sale</h1>
      <div class="flash-sale__intro-wrapper">
        <div class="flash-sale__description">
          <p>
            Pick ANY INE Security certification and save 50% - No subscription required, 3 days
            only! Code at checkout
            <span class="flash-sale__description-couponflash">FLASH50FEB25</span>
          </p>
          <p class="flash-sale__description-highlight">OR</p>
          <p>
            Choose a Certification + Prep Bundle and save 50%. Code at checkout
            <span class="flash-sale__description-couponbundle">BUNDLE50FEB25</span>
          </p>
        </div>
        <div class="flash-sale__intro">Shop savings below</div>
      </div>
    </div>
    <div class="flash-sale__icon">
      <div class="flash-sale__icon-logo-wrapper">
        <img :src="FlashSaleLogoImg" alt="Train, Certify, & Save" class="flash-sale__icon-logo" />
      </div>
    </div>
  </section>
</template>

<script>
import FlashSaleLogoPng from '@/assets/images/hero-section/flash-sale/flash-sale-logo.png'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'FlashSaleHeroSection',
  mixins: [routesRules],
  data() {
    return {
      FlashSaleLogoImg: FlashSaleLogoPng,
    }
  },
}
</script>

<style lang="scss" scoped>
.flash-sale {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  flex-flow: column-reverse;
  align-items: center;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    flex-flow: row;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0 100px 0;
  }
  &__title {
    color: var(--white);
    font-family: var(--font-medium);
    font-size: rem(35px);
    font-style: normal;
    font-weight: 900;
    line-height: rem(37px);
    margin: 0;
    @include mobile {
      font-size: rem(40px);
    }
    @include desktop {
      font-size: rem(54px);
      line-height: rem(50px);
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    p {
      margin: 0 0 10px 0;
    }
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    width: 100%;

    &-highlight {
      color: var(--white);
      font-weight: 700;
    }
    &-couponflash {
      color: #88ebfe;
      font-weight: 700;
    }
    &-couponbundle {
      color: #fb99b3;
      font-weight: 700;
    }

    @include mobile {
      width: 100%;
    }
    @include desktop {
      width: 85%;
      font-size: rem(24px);
      line-height: 32px;
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    margin-top: -40px;

    @include mobile {
      width: 90%;
      margin-top: 0;
    }

    @include desktop {
      width: 100%;
      margin-top: 0;
    }
  }
  &__icon {
    position: relative;
    top: -40px;
    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      box-shadow: -1px 1px 29px 18px var(--gray-purple) inset;
      margin: 30px auto;
      display: flex;
      justify-content: center;
      @include mobile {
        width: 300px;
      }
      @include desktop {
        width: 515px;
      }
    }
  }
}
</style>
